<template>
  <div class="plv-iar-product__popup-link">
    <mobile-modal
      width="100%"
      :height="460"
      :show-close="true"
      @close="close()"
    >
      <iframe :src="href" frameborder="0" style="width: 100%; height: 100%;"></iframe>
    </mobile-modal>
  </div>
</template>

<script>
import mixin from './mixin';
import MobileModal from '@/components/common/modal/MobileModal.vue';

export default {
  mixins: [mixin],
  components: { MobileModal }
};
</script>
